<template>
  <div class="margin-neg">
    <b-row>
      <b-col sm="4" md="2" style="padding-bottom: 1rem">
        <b-button style="position:absolute; bottom:1rem; left:12px;"
                  v-on:click="$router.push('/s_create')"
                  variant="success"
                  class="px-4 mr-3 mt-auto">Serie anlegen
        </b-button>
      </b-col>
      <b-col sm="2" md="1">
        <b-form-group
            id="bh_zu"
            label="Zuständigkeit:"
            label-for="bh_zu_in"
        ><div style="z-index: 20; cursor:pointer">
          <b-form-select id="bh_zu_in"
                         style="background: white"
                         :plain="true"
                         :value="selectedKostMigr.id"
                         :value-field="'id'"
                         :text-field="'text'"
                         :options="[selectedKostMigr]"
                         @click.stop="showBhModal"
                         disabled
                         size="sm">
          </b-form-select>
          <div style="position:absolute; left:0; right:0; top:0; bottom:0; inset: 18px;" @click="showBhModal"></div>
        </div>
        </b-form-group>
      </b-col>
      <b-col md="1" sm="2">
        <b-form-group
            id="active"
            label="Aktiv:"
            label-for="active-select"
        >
          <b-form-select id="active-select"
                         :plain="true"
                         :options="activeSelects"
                         v-model="activeSelect"
                         size="sm">
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col>
      </b-col>
      <b-col sm="2" md="2" class="ml-auto" style="padding-bottom: 1rem"
             v-on:keypress.enter="searchText">
        <b-form-input
            style="position:absolute; bottom:1rem; left:0;"
            v-model="fullTextSearch"
            placeholder="Suche"></b-form-input>
      </b-col>
      <b-col sm="2" md="1" style="padding-bottom: 1rem">
        <b-button style="position:absolute; bottom:1rem; left:12px;"
                  v-on:click="searchText"
                  variant="primary"
                  class="px-4 mr-3 mt-auto">Suchen
        </b-button>
      </b-col>
    </b-row>
    <b-modal size="m" v-model="showChangeKostMigr" centered title="Zuständigkeit anpassen"
    >
      <b-row class="mt-2">
        <b-col>
          <v-jstree ref="js_tree" :allow-transition="false"
                    style="flex: 1 0; border: 1px solid #c0c0c0; border-radius: 0.25rem;"
                    class="my-tree" :data="kostMigrs"
                    @item-click="onKostMigrClicked"
                    show-checkbox></v-jstree>
        </b-col>
      </b-row>
      <template #modal-footer="{ok, cancel}">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="md" variant="primary" @click="cancel">
          Abbrechen
        </b-button>
        <b-button size="md" :disabled="!selectedKostMigrInt" variant="success" @click="setKostMigr">
          OK
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import RefreshIcon from 'vue-material-design-icons/Refresh.vue';
import VJstree from 'vue-jstree'

export default {
  components: {
    VJstree, RefreshIcon},
  props: {
    onSearch: {
      type: Function,
      default: undefined
    },
    bauhofStructure: {
      type: Array,
      default: () => []
    },
  },
  name: "TaskSeriesSearchbar",
  computed: {
  },
  data: () => {
    return {
      fullTextSearch: "",
      wasMounted: false,
      activeSelect: true,
      activeSelects: [
        {text: "Aktiv", value: true},
        {text: "Inaktiv", value: false},
      ],
      kostMigrs : [],
      selectedKostMigr: {id: "all", text: "Alle"},
      selectedKostMigrInt: null,
      showChangeKostMigr: false,
    }
  },
  methods: {
    onKostMigrClicked(node, item, e) {
      this.selectedKostMigrInt = item;
    },
    setKostMigr() {
      this.showChangeKostMigr = false;
      this.selectedKostMigr = this.selectedKostMigrInt;
      this.selectedKostMigrInt = null;
    },
    showBhModal() {
      this.selectedKostMigrInt = null;
      this.showChangeKostMigr = true;
    },
    searchText() {
      if (this.onSearch !== undefined) {
        this.onSearch(
            this.activeSelect,
            this.fullTextSearch,
            this.selectedKostMigr.id,
        )
      }
    },
    searchFilter() {
      if (this.onSearch !== undefined) {
        this.onSearch(
            this.activeSelect,
            this.fullTextSearch,
            this.selectedKostMigr.id,
        )
      }
    },
    onFirstSearch() {
      this.wasMounted = true;
    },
    computeKostMigrs(data) {
      data.sort((a,b) => (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : ((b.text.toLowerCase() > a.text.toLowerCase()) ? -1 : 0));
      let res = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].node_type !== "user") {
          let cur = {...data[i]}
          cur.children = this.computeKostMigrs(cur.children)
          res.push(cur)
        }
      }
      return res;
    },
    setQuery({active, searchText, groupId}) {
      this.activeSelect = active;
      this.fullTextSearch = searchText;
      this.setFindKostMigr(groupId, this.kostMigrs);
    },
    setFindKostMigr(id, kostMigrs) {
      let stack = [...kostMigrs];
      while (stack.length > 0) {
        let cur = stack.pop();
        if (cur.id === id) {
          this.selectedKostMigr = cur;
          return;
        }
        if (cur.children) {
          for (let i = 0; i < cur.children.length; i++) {
            stack.push(cur.children[i]);
          }
        }
      }
    }
  },
  watch: {
    bauhofStructure(n, o) {
      if (!n || !n.length) {
        return;
      }
      let root = [{
        disabled: false,
        id: "all",
        node_type: "all",
        opened: true,
        selected: false,
        text: "Alle",
        icon: "none",
        children: this.computeKostMigrs(JSON.parse(JSON.stringify(n))),
      }]
      this.kostMigrs = root;
      console.log(this.kostMigrs)
    },

    activeSelect: function(newVal, oldVal) {
      if (this.wasMounted) {
        this.searchFilter();
      }
    },
    selectedKostMigr: function (newVal, oldVal) {
      if (this.wasMounted) {
        this.searchFilter();
      }
    }
  }
}
</script>

<style scoped>

::v-deep .btn.active > .calendar-item {
  color: black;
  border-color: black;
}
.margin-neg {
  background: #fbfbfb;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 1rem;
}
.form-control {
  color: black;
}
.ic-chevron {
  color: #696969;
  vertical-align: middle;
  cursor: pointer;
  margin: 0px;
}
::v-deep .material-design-icon > .material-design-icon__svg {
  bottom: inherit;
}

::v-deep .refresh-icon > .material-design-icon__svg {
  bottom: auto !important;
}

::v-deep .btn.btn-secondary {
  background: white;
  cursor: pointer;
}
.calendar-item {
  height: 1.5rem;
  width: 1.5rem;
  position: inherit;
  vertical-align: middle;
  border: 2px solid #696969;
  border-radius: 0.25rem;
  display: inline-block;
  align-self: center;
  color: #696969;
}

.filter-active {
  background-color: #018a33 !important;
  border-color: #02411b !important;
  color: white !important;
}

::v-deep .tree-icon.none {
  display: none;
}

::v-deep .month-picker-input {
  padding: 0.25rem 0.5rem;
  font-size: 0.765625rem;
  line-height: 1.5;
  border-radius: 0.2rem;
  color: black;
  font-weight: 400;
  border: 1px solid #c0c0c0;
  width: 100%;
  height: 26px;
}

::v-deep .month-picker-input-container {
  height: 26px;
  margin-top: 0.5rem;
  width: 60%;
}

::v-deep .month-picker__container {
  z-index: 100;
}
</style>

<style>
.no-select{
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
.ic-chevron > .material-design-icon__svg {
  position: inherit !important;
}

</style>
